// ==============================|| ANALYTICS — PUBLIC API ||============================== //
// The single import point for product tracking:
//
//   import { analytics } from 'lib/analytics';
//   analytics.accountConnected({ platform, broker_name });
//
// The React provider is imported directly from its own file so this barrel stays
// cheap; platform codes come from constants/platforms.

export { analytics } from './analytics';

export type { AnalyticsEvent, AnalyticsEventName, ExitReasonProps, PropsFor, Platform } from './events';
export type { SurveyResponseValue, SurveySubmission } from './types';
